import { Injectable } from '@angular/core';
import { BusinessPropertiesObject } from 'src/app/models/tasks/tasks-properties/business-properties/business-properties-object.model';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { StringUtils } from 'src/app/services/utils/string.utils';

@Injectable({
    providedIn: 'root'
})
export class TaskBusinessPropertiesConverter implements Converter<BusinessPropertiesObject>{

    public convert(input: any): BusinessPropertiesObject {
        try {
            if (isNullOrUndefined(input)) return BusinessPropertiesObject.create();
            return new BusinessPropertiesObject(StringUtils.default(input.order.id), StringUtils.default(input.order.crmId));
        } catch (error) {
            console.error(error);
            return BusinessPropertiesObject.create();
        }
    }

}
